import { render, staticRenderFns } from "./StockFeature.vue?vue&type=template&id=6cc9cbc1&scoped=true"
import script from "./StockFeature.vue?vue&type=script&lang=js"
export * from "./StockFeature.vue?vue&type=script&lang=js"
import style0 from "./StockFeature.vue?vue&type=style&index=0&id=6cc9cbc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc9cbc1",
  null
  
)

export default component.exports